<template>
    <FGridWindow  ref="gridWindow" url="/sys/compMng/company/find" :config="windowConfig" 
                  :show=shows 
                  :windowToBody=appendBody
                  @onClose="onClose"
                  @onSelected="onSelected">        
    </FGridWindow>
</template>

<script>
import FGridWindow from 'components/window/SearchWindow.vue';
export default {
    components:{
        FGridWindow
    },
    props:{
      show:{
          Type:Boolean,
          default(){
              return true;
          }
      },
      windowToBody:{
          Type:Boolean,
          default(){
              return false;
          }
      }
    },
    watch:{
      show: {
            handler(newVal, oldVal) {
                console.info('value changed 2', newVal)
                this.shows=newVal;
            },
            deep: true
      },
      windowToBody(newVal,oldVal){
          this.toBody=newVal;
      }
    },
    data(){
        return {
            shows:this.show,
            appendBody:this.windowToBody,
            windowConfig:{
                formConfig: {
                    titleWidth: 100,
                    titleAlign: 'right',          
                    
                    items: [
                        { field: 'companyName', type:"radio",title: '公司名称:', span: 8, size:"mini",itemRender: { name: 'input', attrs: { placeholder: '请输入查询条件' } } },
                        { field: 'companyCode', title: '公司编码:', span: 8,size:"mini", itemRender: { name: 'input', attrs: { placeholder: '请输入查询条件' } } },
                        { span: 8, align: 'right', collapseNode: true,size:"mini",itemRender: { name: '$buttons', children: [{ props: { type: 'submit',content: '查询', status: 'primary' } }, { props: { type: 'reset',content: '重置' } }] }  },
                        {
                        span: 8,
                        folding: true
                        },
                    ],
                    data: {
                        goodsCode: '',
                        goodsDesc: ''
                    }
                },
                // radioConfig:{labelField: 'companyName', highlight: true},
                // radio-config="{labelField: 'name', trigger: 'row'}
                tableConfig:{
                   columns:[
                            // { type: 'checkbox', width: 60, fixed: 'left' },
                            // { type: 'seq', width: 80,  title: '序号',fixed: 'left' },
                            { type: 'radio', width: 60, title: '选项',fixed: 'left' },					
                            { type: 'seq',  field: 'companyId', title: '公司ID'},
                            { field: 'companyCode', title: '公司编码'},
                            { field: 'companyName', title: '公司名'}
                    ]
               },
               toolbar:[{
                    class:"toolbar-item edit_btn",
                    name:"选取",
                    click:"onSelected"
                }]
            }
        }
    },
    methods:{
        onClose(value){
            this.shows=value;
             this.$emit("onClose",this.shows);    
        },
        onSelected(gridWindow){
            let gridWindowData = gridWindow.getRadioRecord()
            console.log(gridWindowData)  
            this.$emit("onSelectedCompany",gridWindowData);
        }
    }
    
}
</script>